import { forwardRef, type ComponentProps, type PropsWithChildren } from 'react';

interface ExternalLinkProps extends PropsWithChildren {
  href: ComponentProps<'a'>['href'];
  ariaLabel: string;
  className?: string;
  label?: string;
}

export const ExternalLink = forwardRef<HTMLAnchorElement, ExternalLinkProps>(
  ({ children, href, ariaLabel, className, label }, ref) => {
    return (
      <a
        ref={ref}
        href={href}
        target="_blank"
        className={className}
        aria-label={ariaLabel}
        title={ariaLabel}
        rel="noopener noreferrer"
      >
        {children}
        {label && <span className="h-5">{label}</span>}
      </a>
    );
  },
);

ExternalLink.displayName = 'ExternalLink';
